// extracted by mini-css-extract-plugin
export default {"chatMessage":"ChatMessage_chatMessage__a8ckB"};